// Lazy-loaded e-learning screens (the route table is elearningRoutes.ts).

import { ComponentType, ReactNode, Suspense, lazy } from 'react'
import SuspenseLoader from '../components/SuspenseLoader'

const Loader =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P): ReactNode =>
    (
      <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
      </Suspense>
    )

export const Layout = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Layout')))
export const List = Loader(lazy(() => import('../pages/admins/content/management/Elearning')))
export const ElearningForm = Loader(lazy(() => import('../pages/admins/content/management/Elearning/ElearningForm')))
export const Modules = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Modules')))
export const ModuleForm = Loader(lazy(() => import('../pages/admins/content/management/Elearning/ModuleForm')))
export const Chapters = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Chapters')))
export const Pages = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Pages')))
export const PageEditor = Loader(lazy(() => import('../pages/admins/content/management/Elearning/PageEditor')))
export const Library = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Library')))
export const Results = Loader(lazy(() => import('../pages/admins/content/management/Elearning/Results')))
export const Participant = Loader(lazy(() => import('../pages/admins/content/management/Elearning/ParticipantPage')))
